import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  duplicationText,
  getTargetProjectNotice,
} from '../../../constants/initiativeDuplication.js';
import { retrieveDuplicationPreview } from '../../../modules/initiativeDuplications.js';
import styles from './DuplicateInitiativeModal.module.css';

const mapDispatchToProps = { retrieveDuplicationPreview };

/**
 * What changes in another target project: the owner, when the source owner has
 * no access there, and the stakeholders that will be added to it.
 * The preview is loaded again whenever another project is picked.
 */
const TargetProjectNotice = ({
  initiative,
  targetProject,
  copyStakeholders,
  retrieveDuplicationPreview,
}) => {
  // undefined while loading, null when the preview failed
  const [preview, setPreview] = useState(undefined);

  useEffect(() => {
    let current = true;

    setPreview(undefined);
    retrieveDuplicationPreview(initiative.type, initiative.id, targetProject.id)
      .then((result) => current && setPreview(result))
      .catch(() => current && setPreview(null));

    // A late answer for a project that is no longer picked is ignored.
    return () => {
      current = false;
    };
  }, [initiative.type, initiative.id, targetProject.id]);

  const notice = getTargetProjectNotice({
    targetProject,
    copyStakeholders,
    preview,
  });

  if (!notice) return null;

  return (
    <div className={styles.notice} role="status" aria-live="polite">
      <strong>
        {duplicationText('targetNotice.title', { target: notice.project })}
      </strong>
      {notice.loading ? (
        <p className={styles.softText}>
          {duplicationText('targetNotice.loading')}
        </p>
      ) : (
        <ul>
          {notice.lines.map((line) => (
            <li key={line}>{line}</li>
          ))}
        </ul>
      )}
    </div>
  );
};

TargetProjectNotice.propTypes = {
  initiative: PropTypes.shape({
    id: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
  }).isRequired,
  targetProject: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  copyStakeholders: PropTypes.bool.isRequired,
};

export default connect(null, mapDispatchToProps)(TargetProjectNotice);
